module.exports = __webpack_public_path__ + "static/media/Roboto-BoldItalic.41db5f54.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-BoldItalic.ttf
// module id = 521
// module chunks = 0